import { requestJson, type ApiEnvelope } from '@shared/api/http';
import type { CallBootstrap, CallHistoryEntry, CallHistoryFilter, CallHistoryPage } from './types';

export async function fetchCallBootstrap(
  apiBase: string,
  deviceId?: string,
): Promise<CallBootstrap> {
  const query = new URLSearchParams();
  if (deviceId) {
    query.set('deviceId', deviceId);
  }
  query.set('platform', 'web');
  const suffix = query.toString() ? `?${query.toString()}` : '';
  const response = await requestJson<ApiEnvelope<CallBootstrap>>(`/call/bootstrap${suffix}`, {
    baseUrl: apiBase,
  });
  return response.data as CallBootstrap;
}

export async function fetchCallHistory(
  apiBase: string,
  options: { filter: CallHistoryFilter; limit?: number; cursor?: string },
): Promise<CallHistoryPage> {
  const query = new URLSearchParams({
    filter: options.filter,
    limit: String(options.limit ?? 50),
  });
  if (options.cursor) query.set('cursor', options.cursor);
  const response = await requestJson<ApiEnvelope<CallHistoryPage>>(
    `/call/history?${query.toString()}`,
    { baseUrl: apiBase },
  );
  return response.data as CallHistoryPage;
}

export async function setCallHistoryHidden(
  apiBase: string,
  callId: string,
  hidden: boolean,
): Promise<CallHistoryEntry> {
  const response = await requestJson<ApiEnvelope<CallHistoryEntry>>(
    `/call/history/${encodeURIComponent(callId)}/visibility`,
    {
      baseUrl: apiBase,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hidden }),
    },
  );
  return response.data as CallHistoryEntry;
}
